module.exports = __webpack_public_path__ + "static/media/aboutMain.498acb84.png";